module.exports = __webpack_public_path__ + "static/media/estimation.4778580a.jpg";